import React, { useEffect, useState } from "react";
import getServices from "../../Services/getServices";
import ListingCom from "./ListingCom";
import Listing from "../../Assets/images/listing.png";
import EmptyStateGif from "../../Assets/gif/gif.gif";

function TopListing() {
  const [topListings, setTopListings] = useState([]);

  const getData = () => {
    getServices
      .getAllListing()
      .then((response) => {
        setTopListings(response.data.investmentPlans.reverse() || []);
      })
      .catch((error) => {
        setTopListings([]);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const filteredListings = topListings.filter(
    (item) => item.propertyStatus === "active"
  );

  return (
    <div className="mt-10 bg-[#FAFAFA]">
      <div className="px-2 py-4 md:px-20">
        <h5 className="text-back-color2 text-[32px] font-extrabold py-5 wow animate__animated animate__fadeInLeft">
          Top listings
        </h5>
        <div className="grid md:grid-cols-3 gap-5">
          {filteredListings.slice(0, 3).map((item, index) => (
            <div key={index}>
              <ListingCom
                name={item.title}
                img={item.imageUrl?.[0] ?? Listing}
                count={item.imageUrl?.length ?? 1}
                desc={item.description}
                start={item.createdDate?.slice(0, 10) ?? "No Date"}
                price={item.price}
                location={item.locality}
                area={item.coveredArea}
                plot={item.totalPlots}
              />
            </div>
          ))}
        </div>
        {filteredListings.length === 0 && (
          <div className="flex flex-col items-center justify-center py-10">
            <img
              src={EmptyStateGif}
              alt="No active Top Listing currently"
              className="w-48 h-48 object-contain"
            />
            <p className="text-center text-gray-500 text-xl mt-4">
              Any recent Top listing will appear here
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopListing;
